import { Tabs, Tab } from '@mui/material';
import { JMC_COLORS } from '../../styles/colors';

function CustomTabs({ tabValue, handleTabChange, tabs }) {
  return (
    <Tabs
      value={tabValue}
      onChange={handleTabChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        backgroundColor: 'white',
        borderBottom: tabs[tabValue]?.color || '1px solid rgba(0,0,0,0.08)',
        minHeight: 0,
        px: 0,
        '& .MuiTabs-flexContainer': {
          justifyContent: 'flex-start',
        },
        '& .MuiTabs-scrollButtons': {
          '&.Mui-disabled': {
            opacity: 0.3,
          },
        },
        '& .MuiTabs-indicator': {
          backgroundColor: tabs[tabValue]?.color || JMC_COLORS.primary,
          height: 4,
          borderRadius: '4px 4px 0 0',
        },
      }}
    >
      {tabs?.map((tab, index) => (
        <Tab
          key={index}
          label={tab.label}
          icon={tab.icon}
          iconPosition="start"
          sx={{
            fontWeight: 600,
            fontFamily: 'Inter, Rubik, sans-serif',
            textTransform: 'none',
            fontSize: '0.95rem',
            minHeight: 0,
            lineHeight: 1,
            py: 1,
            transition: 'all 0.3s ease',
            color: tab.color, 
            '& svg': {
              color: tab.color, 
            },
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)',
              color: tab.color,
              '& svg': {
                color: tab.color,
              },
            },
            '&.Mui-selected': {
              color: tab.color,
              fontWeight: 700,
              backgroundColor: 'white',
              '& svg': {
                color: tab.color,
              },
            },
          }}
        />
      ))}
    </Tabs>
  );
}

export default CustomTabs;
